/*Favourite list*/
$(document).ready(function () {
    // check if anything is in localStorage
    var listContents = JSON.parse(localStorage.getItem('wlist'));
    if(listContents != null && listContents.length > 0){
        // Populate fav list
        $(listContents).each(function (i){  
            $('.favourite-list')
            .append(
                '<li class="favourite-list-item" data-localid="'+listContents[i]["localId"]+'">' +
                '<a href="'+ listContents[i]["localId"] +'">' +
                '<span class="icon"></span>' +
                '<span class="remove">Remove</span>' +
                listContents[i]["localTitle"] +
                '</a>'+
                '</li>'
            );
        })   
    } else{
         $('.favourite-list')
            .append(
                '<li class="no-favourites">You have no favourites.</li>'
            );
    }

    var favItems = $('.favourite-list-item');
    var editBtn = $('.edit-btn');

    // Click on the edit button to activate deleting links from list
    editBtn.on('click', function () {
        $(this).next('.favourite-list').toggleClass('edit');
        if($(this).hasClass('editing')){
            $(this).html("Edit").removeClass('editing');
           
        } else{
            $(this).html("Close edit mode").addClass('editing');
        }
       
        // When list is in edit mode, prevent normal link behaviour
        /*$('.favourite-list.edit .favourite-list-item').on('click','a', function(e){
            e.preventDefault();
        })*/
       
        // Click on the remove button removes link from the list and local storage
        $('.favourite-list-item').on('click', '.remove', function (e) {
            e.preventDefault();
           
            // Hide the remove button
            $(this).hide();

            // Get the localID from the list item surounding the remove button
            var localId = $(this).parent().parent().data('localid');
           
            removeAddedClass(localId);

            // Get latest list
            listContents = JSON.parse(localStorage.getItem('wlist'));
           
            // Filter away the list item clicked
            listContents = listContents.filter(function(el) {
                return el.localId !== localId;
            });
            // Save to local storage
            localStorage.setItem("wlist",JSON.stringify(listContents));
           
            // Animate/hide the list item
            $(this).parent().parent().animate({
                opacity: 0,
                padding: 0,
                height: 0
            }, 350, function () {
                // After animation is done, remove the item from the DOM
                $(this).remove();
               
                // Get the latest list to check if it has links
                var theList = JSON.parse(localStorage.getItem('wlist'));
               
                // If the list has no links, remove edit class and append no fav text
                if(theList.length < 1){
                    $('.favourite-list')
                        .removeClass('edit')
                        .append('<li class="no-favourites">You have no favourites.</li>');
                    $(editBtn).html("Edit").removeClass('editing');
                }

            });
        });
    })

    /* */
    function removeAddedClass(listItem){
            $(".add-links a.wlist[data-localid='" + listItem + "']").removeClass('added').html("Add to shortcuts");
    }
})